<template>
    <div class="inner-container">
        <div class="section-title budget">
            <i class="icon icon-calculator-coins"></i
            ><span>Бюджетное планирование</span>
        </div>
        <div class="section-subtitle">
            <i class="icon icon-grid"></i>Интеграции/загрузка
        </div>
        <b-tabs lazy>
            <b-tab title="План по доходам">
                <b-overlay
                    id="over1"
                    :show="busy1"
                    rounded="sm"
                    :opacity="0.8"
                    spinner-variant="primary"
                    spinner-type="grow"
                    spinner-small
                >
                    <div class="card-loader-top">
                        <b-row>
                            <b-col cols="12" lg="6">
                                <b-form-group
                                    id="form-file-1"
                                    label="Файл для загрузки:"
                                    label-for="file"
                                    description="Выберите файл формата .xls, .xlsx"
                                >
                                    <b-form @submit.stop.prevent>
                                        <b-form-file
                                            id="file"
                                            accept=".xls, .xlsx, .pdf"
                                            placeholder="Выберите файл"
                                            v-model="file1"
                                            ref="file-input"
                                            browse-text="Обзор"
                                            @input="inputFile1()"
                                        >
                                        </b-form-file>
                                    </b-form>
                                </b-form-group>
                            </b-col>
                        </b-row>
                    </div>
                    <file-loader
                        :prop-data="fileProp"
                        :file-body="fileBody"
                        :file-name="file1.name"
                        :file="file1"
                        v-on:form-clear="formClear"
                        v-on:save-load="saveLoad"
                    ></file-loader>
                </b-overlay>
            </b-tab>
            <b-tab title="Форма 2-19">
                <b-overlay
                    id="over2"
                    :show="busy2"
                    rounded="sm"
                    :opacity="0.8"
                    spinner-variant="primary"
                    spinner-type="grow"
                    spinner-small
                >
                    <div class="card-loader-top">
                        <b-row>
                            <b-col cols="12" lg="6">
                                <b-form-group
                                    id="form-file-2"
                                    label="Файл для загрузки:"
                                    label-for="file219"
                                    description="Выберите файл формата .pdf"
                                >
                                    <b-form @submit.stop.prevent>
                                        <b-form-file
                                            id="file219"
                                            accept=".xls, .xlsx, .pdf"
                                            placeholder="Выберите файл"
                                            v-model="file219"
                                            ref="file-input"
                                            browse-text="Обзор"
                                            @input="inputFile219()"
                                        >
                                        </b-form-file>
                                    </b-form>
                                </b-form-group>
                            </b-col>
                        </b-row>
                    </div>
                    <pdf-loader
                        :prop-data="fileProp219"
                        :file-body="fileBody219"
                        :file-name="file219.name"
                        :file="file219"
                        v-on:form-clear219="formClear219"
                        v-on:save-load219="saveLoad219"
                    ></pdf-loader>
                </b-overlay>
            </b-tab>
            <b-tab title="Форма 2-43">
                <b-overlay
                    id="over3"
                    :show="busy3"
                    rounded="sm"
                    :opacity="0.8"
                    spinner-variant="primary"
                    spinner-type="grow"
                    spinner-small
                >
                    <div class="card-loader-top">
                        <b-row>
                            <b-col cols="12" lg="6">
                                <b-form-group
                                    id="form-file-2"
                                    label="Файл для загрузки:"
                                    label-for="file219"
                                    description="Выберите файл формата .pdf"
                                >
                                    <b-form @submit.stop.prevent>
                                        <b-form-file
                                            id="file243"
                                            accept=".xls, .xlsx, .pdf"
                                            placeholder="Выберите файл"
                                            v-model="file243"
                                            ref="file-input"
                                            browse-text="Обзор"
                                            @input="inputFile243()"
                                        >
                                        </b-form-file>
                                    </b-form>
                                </b-form-group>
                            </b-col>
                        </b-row>
                    </div>
                    <pdf-loader243
                        :prop-data="fileProp243"
                        :file-body="fileBody243"
                        :file-name="file243.name"
                        :file="file243"
                        v-on:form-clear243="formClear243"
                        v-on:save-load243="saveLoad243"
                    ></pdf-loader243>
                </b-overlay>
            </b-tab>
            <b-tab title="План по расходам">
                <b-overlay
                    id="over5"
                    :show="busy5"
                    rounded="sm"
                    :opacity="0.8"
                    spinner-variant="primary"
                    spinner-type="grow"
                    spinner-small
                >
                    <div class="card-loader-top">
                        <b-row>
                            <b-col cols="12" lg="6">
                                <b-form-group
                                    id="form-file-5"
                                    label="Файл для загрузки:"
                                    label-for="file5"
                                    description="Выберите файл формата .xls, .xlsx"
                                >
                                    <b-form @submit.stop.prevent>
                                        <b-form-file
                                            id="file5"
                                            accept=".xls, .xlsx"
                                            placeholder="Выберите файл"
                                            v-model="file5"
                                            ref="file-input"
                                            browse-text="Обзор"
                                            @input="inputFile5()"
                                        >
                                        </b-form-file>
                                    </b-form>
                                </b-form-group>
                            </b-col>
                        </b-row>
                    </div>
                    <exp-loader
                        :prop-data="fileProp5"
                        :file-body="fileBody5"
                        :file-name="file5.name"
                        :file="file5"
                        v-on:form-clear="formClear5"
                        v-on:save-load="saveLoad5"
                    ></exp-loader>
                </b-overlay>
            </b-tab>
            <b-tab title="Форма 5-52">
                <b-overlay
                    id="over4"
                    :show="busy4"
                    rounded="sm"
                    :opacity="0.8"
                    spinner-variant="primary"
                    spinner-type="grow"
                    spinner-small
                >
                    <div class="card-loader-top">
                        <b-row>
                            <b-col cols="12" lg="6">
                                <b-form-group
                                    id="form-file-4"
                                    label="Файл для загрузки:"
                                    label-for="file552"
                                    description="Выберите файл формата .pdf"
                                >
                                    <b-form @submit.stop.prevent>
                                        <b-form-file
                                            id="file552"
                                            accept=".pdf"
                                            placeholder="Выберите файл"
                                            v-model="file552"
                                            ref="file-input"
                                            browse-text="Обзор"
                                            @input="inputFile552()"
                                        >
                                        </b-form-file>
                                    </b-form>
                                </b-form-group>
                            </b-col>
                        </b-row>
                    </div>
                    <expend-loader
                        :prop-data="fileProp552"
                        :file-body="fileBody552"
                        :file-name="file552.name"
                        :file="file552"
                        v-on:form-clear552="formClear552"
                        v-on:save-load552="saveLoad552"
                    ></expend-loader>
                </b-overlay>
            </b-tab>
            <b-tab title="Форма 5-34a">
                <b-overlay
                    id="over3"
                    :show="busy3"
                    rounded="sm"
                    :opacity="0.8"
                    spinner-variant="primary"
                    spinner-type="grow"
                    spinner-small
                >
                    <div class="card-loader-top">
                        <b-row>
                            <b-col cols="12" lg="6">
                                <b-form-group
                                    id="form-file-2"
                                    label="Файл для загрузки:"
                                    label-for="file219"
                                    description="Выберите файл формата .pdf"
                                >
                                    <b-form @submit.stop.prevent>
                                        <b-form-file
                                            id="file534A"
                                            accept=".pdf"
                                            placeholder="Выберите файл"
                                            v-model="file534A"
                                            multiple
                                            ref="file-input"
                                            browse-text="Обзор"
                                            @input="inputFile534A()"
                                        >
                                        </b-form-file>
                                    </b-form>
                                </b-form-group>
                            </b-col>
                            <b-table
                                v-if="tableFiles534A.length>0"
                                :items="tableFiles534A"
                                :fields="file_fields"
                                small
                                striped
                                hover
                                selectable
                                select-mode="single"
                                class="mt-3"
                                @row-clicked="table_row_clicked"
                            >
                            </b-table>
                            <b-button v-if="tableFiles534A.length>0" variant="success" @click="load_all">Загрузить всё</b-button>
                        </b-row>
                    </div>
                    <pdf-loader534A
                        ref="pdfLoader534A"
                        :prop-data="fileProp534A"
                        :file-body="fileBody534A"
                        :file="selectedFile534A"
                        v-on:form-clear534A="formClear534A"
                        v-on:save-load534A="saveLoad534A"
                    ></pdf-loader534A>
                </b-overlay>
            </b-tab>
            <b-tab title="Форма 5-34">
                <b-overlay
                    id="over3"
                    :show="busy3"
                    rounded="sm"
                    :opacity="0.8"
                    spinner-variant="primary"
                    spinner-type="grow"
                    spinner-small
                >
                    <div class="card-loader-top">
                        <b-row>
                            <b-col cols="12" lg="6">
                                <b-form-group
                                    id="form-file-2"
                                    label="Файл для загрузки:"
                                    label-for="file219"
                                    description="Выберите файл формата .pdf"
                                >
                                    <b-form @submit.stop.prevent>
                                        <b-form-file
                                            id="file534"
                                            accept=".pdf"
                                            multiple
                                            placeholder="Выберите файл"
                                            v-model="file534"
                                            ref="file-input"
                                            browse-text="Обзор"
                                            @input="inputFile534()"
                                        >
                                        </b-form-file>
                                    </b-form>
                                </b-form-group>
                            </b-col>
                            <b-table
                                v-if="tableFiles534.length>0"
                                :items="tableFiles534"
                                :fields="file_fields"
                                small
                                striped
                                hover
                                selectable
                                select-mode="single"
                                class="mt-3"
                                @row-clicked="table_row_clicked534"
                            >
                            </b-table>

                            <b-button
                                v-if="tableFiles534.length>0"
                                variant="success"
                                @click="load_all534"
                            >
                                Загрузить всё
                            </b-button>
                        </b-row>
                    </div>
                    <pdf-loader534
                        ref="pdfLoader534"
                        :prop-data="fileProp534"
                        :file-body="fileBody534"
                        :file="selectedFile534"
                        v-on:form-clear534="formClear534"
                        v-on:save-load534="saveLoad534"
                    ></pdf-loader534>
                </b-overlay>
            </b-tab>
            <b-tab title="Форма 5-20">
                <b-overlay
                    id="over3"
                    :show="busy3"
                    rounded="sm"
                    :opacity="0.8"
                    spinner-variant="primary"
                    spinner-type="grow"
                    spinner-small
                >
                    <div class="card-loader-top">
                        <b-row>
                            <b-col cols="12" lg="6">
                                <b-form-group
                                    id="form-file-2"
                                    label="Файл для загрузки:"
                                    label-for="file219"
                                    description="Выберите файл формата .pdf"
                                >
                                    <b-form @submit.stop.prevent>
                                        <b-form-file
                                            id="file520"
                                            accept=".pdf"
                                            placeholder="Выберите файл"
                                            v-model="file520"
                                            ref="file-input"
                                            browse-text="Обзор"
                                            @input="inputFile520()"
                                        >
                                        </b-form-file>
                                    </b-form>
                                </b-form-group>
                            </b-col>
                        </b-row>
                    </div>
                    <!--                    <pre>{{fileProp520}}</pre>-->
                    <pdf-loader520
                        :prop-data="fileProp520"
                        :file-body="fileBody520"
                        :file-name="file520.name"
                        :file="file520"
                        v-on:form-clear520="formClear520"
                        v-on:save-load520="saveLoad520"
                    ></pdf-loader520>
                </b-overlay>
            </b-tab>
            <b-tab title="Форма 5-15">
                <b-overlay
                    id="over3"
                    :show="busy3"
                    rounded="sm"
                    :opacity="0.8"
                    spinner-variant="primary"
                    spinner-type="grow"
                    spinner-small
                >
                    <div class="card-loader-top">
                        <b-row>
                            <b-col cols="12" lg="6">
                                <b-form-group
                                    id="form-file-2"
                                    label="Файл для загрузки:"
                                    label-for="file219"
                                    description="Выберите файл формата .pdf"
                                >
                                    <b-form @submit.stop.prevent>
                                        <b-form-file
                                            id="file515"
                                            accept=".pdf"
                                            placeholder="Выберите файл"
                                            v-model="file515"
                                            ref="file-input"
                                            browse-text="Обзор"
                                            @input="inputFile515()"
                                        >
                                        </b-form-file>
                                    </b-form>
                                </b-form-group>
                            </b-col>
                        </b-row>
                    </div>
                    <pdf-loader515
                        :prop-data="fileProp515"
                        :file-body="fileBody515"
                        :file-name="file515.name"
                        :file="file515"
                        v-on:form-clear515="formClear515"
                        v-on:save-load515="saveLoad515"
                    ></pdf-loader515>
                </b-overlay>
            </b-tab>
            <b-tab title="Форма 1-27">
                <b-overlay
                    id="over6"
                    :show="busy6"
                    rounded="sm"
                    :opacity="0.8"
                    spinner-variant="primary"
                    spinner-type="grow"
                    spinner-small
                >
                    <div class="card-loader-top">
                        <b-row>
                            <b-col cols="12" lg="6">
                                <b-form-group
                                    id="form-file-6"
                                    label="Файл для загрузки:"
                                    label-for="file127"
                                    description="Выберите файл формата .xls, .xlsx, .xml"
                                >
                                    <b-form @submit.stop.prevent>
                                        <b-form-file
                                            id="file127"
                                            accept=".xls, .xlsx, .xml"
                                            placeholder="Выберите файл"
                                            v-model="file127"
                                            ref="file-input"
                                            browse-text="Обзор"
                                            @input="inputFile127()"
                                        >
                                        </b-form-file>
                                    </b-form>
                                </b-form-group>
                            </b-col>
                        </b-row>
                    </div>
                    <file-loader127
                        :prop-data="fileProp127"
                        :file-body="fileBody127"
                        :file-name="fileProp127.name"
                        :file="file127"
                        :budget-list="fileHead127.budgetList"
                        v-on:form-clear127="formClear127"
                        v-on:save-load127="saveLoad127"
                    ></file-loader127>
                </b-overlay>
            </b-tab>
            <b-tab title="Форма 4-20">
                <b-overlay
                    id="over7"
                    :show="busy7"
                    rounded="sm"
                    :opacity="0.8"
                    spinner-variant="primary"
                    spinner-type="grow"
                    spinner-small
                >
                    <div class="card-loader-top">
                        <b-row>
                            <b-col cols="12" lg="6">
                                <b-form-group
                                    id="form-file-7"
                                    label="Файл для загрузки:"
                                    label-for="file420"
                                    description="Выберите файл формата .xls, .xlsx"
                                >
                                    <b-form @submit.stop.prevent>
                                        <b-form-file
                                            id="file420"
                                            accept=".xls, .xlsx"
                                            placeholder="Выберите файл"
                                            v-model="file420"
                                            ref="file-input"
                                            browse-text="Обзор"
                                            @input="inputFile420()"
                                        >
                                        </b-form-file>
                                    </b-form>
                                </b-form-group>
                            </b-col>
                        </b-row>
                    </div>
                    <file-loader420
                        :prop-data="fileProp420"
                        :file-body="fileBody420"
                        :file-name="fileProp420.name"
                        :file="file420"
                        :budget-list="fileHead420.budgetList"
                        v-on:form-clear420="formClear420"
                        v-on:save-load420="saveLoad420"
                    ></file-loader420>
                </b-overlay>
            </b-tab>
            <b-tab title="Форма 4-20 pdf">
                <b-overlay
                    id="over7"
                    :show="busy7"
                    rounded="sm"
                    :opacity="0.8"
                    spinner-variant="primary"
                    spinner-type="grow"
                    spinner-small
                >
                    <div class="card-loader-top">
                        <b-row>
                            <b-col cols="12" lg="6">
                                <b-form-group
                                    id="form-file-7"
                                    label="Файл для загрузки:"
                                    label-for="file420"
                                    description="Выберите файл формата .pdf"
                                >
                                    <b-form @submit.stop.prevent>
                                        <b-form-file
                                            id="file420"
                                            accept=".pdf"
                                            placeholder="Выберите файл"
                                            v-model="file420pdf"
                                            ref="file-input"
                                            browse-text="Обзор"
                                            @input="inputFile420pdf()"
                                        >
                                        </b-form-file>
                                    </b-form>
                                </b-form-group>
                            </b-col>
                        </b-row>
                    </div>
                    <pdf-loader420
                        :prop-data="fileProp420"
                        :file-body="fileBody420"
                        :file-name="file420pdf.name"
                        :file="file420pdf"
                        :budget-list="fileHead420.budgetList"
                        v-on:form-clear420="formClear420pdf"
                        v-on:save-load420="saveLoad420pdf"
                    ></pdf-loader420>
                </b-overlay>
            </b-tab>
            <b-tab title="Форма 3-04">
                <b-overlay
                    id="over7"
                    :show="busy7"
                    rounded="sm"
                    :opacity="0.8"
                    spinner-variant="primary"
                    spinner-type="grow"
                    spinner-small
                >
                    <div class="card-loader-top">
                        <b-row>
                            <b-col cols="12" lg="6">
                                <b-form-group
                                    id="form-file-7"
                                    label="Файл для загрузки:"
                                    label-for="file304pdf"
                                    description="Выберите файл формата .pdf"
                                >
                                    <b-form @submit.stop.prevent>
                                        <b-form-file
                                            id="file304pdf"
                                            accept=".pdf"
                                            placeholder="Выберите файл"
                                            v-model="file304pdf"
                                            ref="file-input"
                                            browse-text="Обзор"
                                            @input="inputFile304()"
                                        >
                                        </b-form-file>
                                    </b-form>
                                </b-form-group>
                            </b-col>
                        </b-row>
                    </div>
                    <pdf-loader304
                        :prop-data="fileProp304"
                        :file-body="fileBody304"
                        :file-name="file304pdf.name"
                        :file="file304pdf"
                        :budget-list="fileHead304.budgetList"
                        v-on:form-clear304="formClear304pdf"
                        v-on:save-load304="saveLoad304pdf"
                    ></pdf-loader304>
                </b-overlay>
            </b-tab>
            <b-tab title="Форма 3-02">
                <b-overlay
                    id="over7"
                    :show="busy7"
                    rounded="sm"
                    :opacity="0.8"
                    spinner-variant="primary"
                    spinner-type="grow"
                    spinner-small
                >
                    <div class="card-loader-top">
                        <b-row>
                            <b-col cols="12" lg="6">
                                <b-form-group
                                    id="form-file-7"
                                    label="Файл для загрузки:"
                                    label-for="file302pdf"
                                    description="Выберите файл формата .pdf"
                                >
                                    <b-form @submit.stop.prevent>
                                        <b-form-file
                                            id="file302pdf"
                                            accept=".pdf"
                                            placeholder="Выберите файл"
                                            v-model="file302pdf"
                                            ref="file-input"
                                            browse-text="Обзор"
                                            @input="inputFile302()"
                                        >
                                        </b-form-file>
                                    </b-form>
                                </b-form-group>
                            </b-col>
                        </b-row>
                    </div>
                    <pdf-loader302
                        :prop-data="fileProp302"
                        :file-body="fileBody302"
                        :file-name="file302pdf.name"
                        :file="file302pdf"
                        :budget-list="fileHead302.budgetList"
                        v-on:form-clear302="formClear302pdf"
                        v-on:save-load302="saveLoad302pdf"
                    ></pdf-loader302>
                </b-overlay>
            </b-tab>
        </b-tabs>
    </div>
</template>

<script>
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import {Ax} from '@/utils';
import FileLoader from '@/modules/budget/components/FileLoader';
import PdfLoader from '@/modules/budget/components/PDFLoader219';
import PdfLoader243 from '@/modules/budget/components/PDFLoader243';
import PdfLoader534A from '@/modules/budget/components/PDFLoader534A';
import PdfLoader534 from '@/modules/budget/components/PDFLoader534';
import PdfLoader420 from '@/modules/budget/components/PDFLoader420';
import PdfLoader304 from '@/modules/budget/components/PDFLoader304';
import PdfLoader302 from '@/modules/budget/components/PDFLoader302';
import PdfLoader520, {Report520} from '@/modules/budget/components/PDFLoader520';
import PdfLoader515 from '@/modules/budget/components/PDFLoader515';
import ExpendLoader from '@/modules/budget/components/ExpendLoader';
import ExpLoader from '@/modules/budget/components/ExpLoader';
import FileLoader127 from '@/modules/budget/components/FileLoader127';
import FileLoader420 from '@/modules/budget/components/FileLoader420';
import File from '@/components/c-icon/variants/file';

export default {
    name: 'BudgetLoader',
    // eslint-disable-next-line vue/no-unused-components
    components: {
        ExpendLoader,
        FileLoader,
        PdfLoader,
        PdfLoader243,
        PdfLoader534A,
        PdfLoader534,
        PdfLoader420,
        PdfLoader304,
        PdfLoader302,
        PdfLoader520,
        PdfLoader515,
        ExpLoader,
        FileLoader127,
        FileLoader420,
    },
    data() {
        return {
            dangReg: 'Наименование',
            file1: [],
            file219: [],
            file243: [],
            file534A: [],
            selectedFile534A: null,
            tableFiles534A: [],
            file534: [],
            selectedFile534: null,
            tableFiles534: [],
            file520: Object,
            file515: Object,
            file420pdf: Object,
            file304pdf: Object,
            file302pdf: Object,
            file552: [],
            file5: [],
            file127: [],
            file420: {},
            fileHead: [],
            fileBody: [],
            fileHead5: [],
            fileBody5: [],
            fileHead219: [],
            fileBody219: [],
            fileHead243: [],
            fileBody243: [],
            fileBody534AMap: new Map(),
            fileBody534A: [],
            fileBody534Map: new Map(),
            fileBody534: [],
            fileBody520: [],
            fileBody515: [],
            fileHead552: [],
            fileBody552: [],
            fileHead127: [],
            fileBody127: [],
            fileHead420: [],
            fileHead304: [],
            fileHead302: [],
            fileBody420: [],
            fileBody304: [],
            fileBody302: [],
            fileName: false,
            fileProp: {
                name: '',
                vid: '',
                period: '',
                data: '',
                mesuare: '',
                region: '',
            },
            fileProp5: {
                name: '',
                vid: '',
                period: '',
                data: '',
                mesuare: '',
                region: '',
            },
            fileProp219: {
                name: '',
                data: '',
                mesuare: '',
                region: '',
                rep_date: '',
            },
            fileProp243: {
                name: '',
                period: '',
                data: '',
                mesuare: '',
                region: '',
                kod_profit: '',
            },
            fileProp534AMap: new Map(),
            fileProp534A: {
                file_name: '',
                report_date: '',
                unit: '',
                budget_type: '',
                region: '',
                period: '',
                abp: '',
                funding_source: '',
                spf: '',
                code_gu: '',
                report_name: ''
            },
            fileProp534Map: new Map(),
            fileProp534: {
                file_name: '',
                report_date: '',
                unit: '',
                budget_type: '',
                region: '',
                period: '',
                abp: '',
                funding_source: '',
                spf: '',
                code_gu: '',
                report_name: ''
            },
            fileProp520: {
                file_name: '',
                report_date: '',
                unit: '',
                budget_type: '',
                region: '',
                period: '',
                abp: '',
                funding_source: '',
                spf: '',
                code_gu: '',
                report_name: '',
                prev_period: '',
                bik: '',
                iik: '',
                year_beginning_balance: 0,
                closing_balance: 0,
                opening_balance: 0,
                region_code: '',
                budget_type_code: '',
                funding_source_code: '',
            },
            fileProp515: {
                file_name: '',
                report_date: '',
                unit: '',
                budget_type: '',
                region: '',
                period: '',
                abp: '',
                funding_source: '',
                spf: '',
                code_gu: '',
                report_name: ''
            },
            fileProp552: {
                name: '',
                vid: '',
                spec: '',
                source: '',
                data: '',
                region: '',
            },
            fileProp127: {
                name: '',
                vid: '',
                year: '',
                day: '',
                month: '',
                mesuare: '',
                region: '',
                rep_date: '',
                isExists: false,
            },
            fileProp420: {
                name: '',
                vid: '',
                year: '',
                repdate: '',
                measure: '',
                region: '',
                abp: '',
                gu: '',
                isExists: false,
            },
            fileProp304: {
                name: '',
                vid: '',
                year: '',
                repdate: '',
                measure: '',
                region: '',
                abp: '',
                gu: '',
                isExists: false,
            },
            fileProp302: {
                name: '',
                vid: '',
                year: '',
                repdate: '',
                measure: '',
                region: '',
                abp: '',
                gu: '',
                isExists: false,
            },
            busy1: false,
            busy2: false,
            busy3: false,
            busy4: false,
            busy5: false,
            busy6: false,
            busy7: false,
            spfMap: new Map(),
            file_fields: [
                { key: "index", label: "#" },
                { key: "name", label: "Имя файла" },
                { key: "status", label: "Статус" },
                { key: "count", label: "Записей" },
                { key: "actions", label: "" }
            ]
        };
    },
    methods: {
        inputFile1() {
            const formData = new FormData();
            if (this.file1 !== null) {
                this.busy1 = true;
                formData.append('file', this.file1, this.file1.name);
                this.FilePPLoad(formData);
            }
        },
        async FilePPLoad(formData) {
            try {
                const response = await fetch('/api-py/check-hplan', {
                    method: 'POST',
                    credentials: 'include',
                    body: formData,
                });
                const result = await response.json();
                if (result === true) {
                    await this.fileHeadLoad(formData);
                } else {
                    this.busy1 = false;
                    this.makeToast(
                        'danger',
                        'Выбранный файл не соответствует шаблону!',
                        'Сообщение'
                    );
                }
            } catch (err) {
                this.busy1 = false;
                this.makeToast('danger', err.toString(), 'Ошибка запроса');
            }
        },
        fileHeadLoad(formData) {
            try {
                Ax(
                    {
                        url: '/api-py/upload-hplan', // Заголовок файла
                        method: 'POST',
                        data: formData,
                    },
                    (data) => {
                        this.busy1 = true;
                        this.fileHead = JSON.parse(data);
                        if (this.fileHead !== null) {
                            this.fileProp.name =
                                this.fileHead[0].names + this.fileHead[1].names;
                            this.fileProp.vid = this.fileHead[2].value;
                            this.fileProp.period = this.fileHead[3].value;
                            this.fileProp.data = this.fileHead[4].value;
                            this.fileProp.mesuare = this.fileHead[5].value;
                            if (this.fileHead[6].value !== this.dangReg) {
                                this.fileProp.region =
                                    this.fileHead[6].value +
                                    ' (' +
                                    this.fileHead[6].regId +
                                    ')';
                            } else {
                                this.fileProp.region = '';
                            }
                            this.fileBodyLoad(formData);
                        }

                        //                    this.busy1 = false;
                    },
                    (error) => {
                        this.error = error;
                        this.busy1 = false;
                    }
                );
            } catch (err) {
                this.busy1 = false;
                this.makeToast('danger', err.toString(), 'Ошибка запроса');
            }
        },
        fileBodyLoad(formData) {
            try {
                Ax(
                    {
                        url: '/api-py/upload-bplan', //  Тело файла
                        method: 'POST',
                        data: formData,
                    },
                    (data) => {
                        this.busy1 = true;
                        this.fileBody = JSON.parse(data);
                        this.busy1 = false;
                    },
                    (error) => {
                        this.error = error;
                        this.busy1 = false;
                    }
                );
            } catch (err) {
                this.busy1 = false;
                this.makeToast('danger', err.toString(), 'Ошибка запроса');
            }
        },
        inputFile5() {
            const formData5 = new FormData();
            if (this.file5 !== null) {
                this.busy5 = true;
                formData5.append('file', this.file5, this.file5.name);
                this.File5Load(formData5);
            }
        },
        async File5Load(formData5) {
            try {
                const response = await fetch('/api-py/check-hfact', {
                    method: 'POST',
                    credentials: 'include',
                    body: formData5,
                });
                const result = await response.json();
                console.log(result);
                if (result === true) {
                    await this.pdfLoadHead5(formData5);
                } else {
                    this.busy5 = false;
                    this.makeToast(
                        'danger',
                        'Выбранный файл не соответствует шаблону!',
                        'Сообщение'
                    );
                }
            } catch (err) {
                this.makeToast('danger', err.toString(), 'Ошибка запроса');
            }
        },
        pdfLoadHead5(formData5) {
            try {
                Ax(
                    {
                        url: '/api-py/upload-hfact', // Заголовок файла
                        method: 'POST',
                        data: formData5,
                    },
                    (data) => {
                        this.busy5 = true;
                        this.fileHead5 = JSON.parse(data);
                        if (this.fileHead5 !== null) {
                            this.fileProp5.name =
                                this.fileHead5[0].names +
                                this.fileHead5[1].names;
                            this.fileProp5.vid = this.fileHead5[2].value;
                            this.fileProp5.period = this.fileHead5[3].value;
                            this.fileProp5.data = this.fileHead5[4].value;
                            this.fileProp5.mesuare = this.fileHead5[5].value;
                            if (this.fileHead5[6].value !== this.dangReg) {
                                this.fileProp5.region =
                                    this.fileHead5[6].value +
                                    ' (' +
                                    this.fileHead5[6].regId +
                                    ')';
                            } else {
                                this.fileProp5.region = '';
                            }
                            this.pdfLoadBody5(formData5);
                        }
                        //this.busy5 = false;
                    },
                    (error) => {
                        this.error = error;
                        this.busy5 = false;
                    }
                );
            } catch (err) {
                this.busy5 = false;
                this.makeToast('danger', err.toString(), 'Ошибка запроса');
            }
        },
        pdfLoadBody5(formData5) {
            try {
                Ax(
                    {
                        url: '/api-py/upload-bfact', //  Тело файла
                        method: 'POST',
                        data: formData5,
                    },
                    (data) => {
                        this.busy5 = true;
                        this.fileBody5 = JSON.parse(data);
                        this.busy5 = false;
                    },
                    (error) => {
                        this.error = error;
                        this.busy5 = false;
                    }
                );
            } catch (err) {
                this.busy5 = false;
                this.makeToast('danger', err.toString(), 'Ошибка запроса');
            }
        },
        inputFile219() {
            const formData219 = new FormData();
            if (this.file219 !== null) {
                this.busy2 = true;
                formData219.append('file', this.file219, this.file219.name);
                this.File219Load(formData219);
            }
        },
        async File219Load(formData219) {
            try {
                const response = await fetch('/api-py/check-h219', {
                    method: 'POST',
                    credentials: 'include',
                    body: formData219,
                });
                const result = await response.json();
                console.log(result);
                if (result === true) {
                    await this.pdfLoadHead(formData219);
                } else {
                    this.busy2 = false;
                    this.makeToast(
                        'danger',
                        'Выбранный файл не соответствует шаблону!',
                        'Сообщение'
                    );
                }
            } catch (err) {
                this.busy2 = false;
                this.makeToast('danger', err.toString(), 'Ошибка запроса');
            }
        },
        pdfLoadHead(formData219) {
            try {
                Ax(
                    {
                        url: '/api-py/upload-h219', // Заголовок файла
                        method: 'POST',
                        data: formData219,
                    },
                    (data) => {
                        // запуск обновления данных о пользователе в общем хранилище
                        // возврат на предыдущую страницу
                        this.fileHead219 = JSON.parse(data);
                        this.fileProp219.name = this.fileHead219[0].fileName;
                        this.fileProp219.data = this.fileHead219[0].data;
                        this.fileProp219.mesuare = this.fileHead219[0].mesuare;
                        this.fileProp219.region = this.fileHead219[0].region;
                        this.fileProp219.rep_date =
                            this.fileHead219[0].rep_date;
                        this.fileProp219.month = this.fileHead219[0].month;
                        this.fileProp219.year = this.fileHead219[0].year;
                        this.pdfLoadBody(formData219);
                    },
                    (error) => {
                        this.error = error;
                    }
                );
            } catch (err) {
                this.busy2 = false;
                this.makeToast('danger', err.toString(), 'Ошибка запроса');
            }
        },
        pdfLoadBody(formData219) {
            try {
                Ax(
                    {
                        url: '/api-py/upload-b219', //  Тело файла
                        method: 'POST',
                        data: formData219,
                    },
                    (data) => {
                        this.busy2 = true;
                        this.fileBody219 = JSON.parse(data);
                        this.busy2 = false;
                    },
                    (error) => {
                        this.error = error;
                        this.busy2 = false;
                    }
                );
            } catch (err) {
                this.busy2 = false;
                this.makeToast('danger', err.toString(), 'Ошибка запроса');
            }
        },
        inputFile243() {
            const formData243 = new FormData();
            if (this.file243 !== null) {
                this.busy3 = true;
                formData243.append('file', this.file243, this.file243.name);
                this.File243Load(formData243);
            }
        },
        async File243Load(formData243) {
            try {
                const response = await fetch('/api-py/check-h243', {
                    method: 'POST',
                    credentials: 'include',
                    body: formData243,
                });
                const result = await response.json();
                console.log(result);
                if (result === true) {
                    await this.pdfLoadHead243(formData243);
                } else {
                    this.busy3 = false;
                    this.makeToast(
                        'danger',
                        'Выбранный файл не соответствует шаблону!',
                        'Сообщение'
                    );
                }
            } catch (err) {
                this.busy3 = false;
                this.makeToast('danger', err.toString(), 'Ошибка запроса');
            }
        },
        pdfLoadHead243(formData243) {
            try {
                Ax(
                    {
                        url: '/api-py/upload-h243', // Заголовок файла
                        method: 'POST',
                        data: formData243,
                    },
                    (data) => {
                        // запуск обновления данных о пользователе в общем хранилище
                        // возврат на предыдущую страницу
                        this.busy3 = true;
                        this.fileHead243 = JSON.parse(data);
                        this.fileProp243.name = this.fileHead243[0].fileName;
                        this.fileProp243.data = this.fileHead243[0].data;
                        this.fileProp243.mesuare = this.fileHead243[0].mesuare;
                        this.fileProp243.region = this.fileHead243[0].region;
                        this.fileProp243.period = this.fileHead243[0].period;
                        this.fileProp243.kod_profit =
                            this.fileHead243[0].kod_profit;
                        this.pdfLoadBody243(formData243);
                    },
                    (error) => {
                        this.error = error;
                        this.busy3 = false;
                    },
                    (this.busy3 = false)
                );
            } catch (err) {
                this.busy3 = false;
                this.makeToast('danger', err.toString(), 'Ошибка запроса');
            }
        },
        pdfLoadBody243(formData243) {
            try {
                Ax(
                    {
                        url: '/api-py/upload-b243', //  Тело файла
                        method: 'POST',
                        data: formData243,
                    },
                    (data) => {
                        this.busy3 = true;
                        this.fileBody243 = JSON.parse(data);
                        this.busy3 = false;
                    },
                    (error) => {
                        this.error = error;
                        this.busy3 = false;
                    }
                );
            } catch (err) {
                this.busy3 = false;
                this.makeToast('danger', err.toString(), 'Ошибка запроса');
            }
        },
        async load_all() {
            for (const tableFiles534AElement of this.tableFiles534A) {
                this.fileProp534A = this.fileProp534AMap.get(tableFiles534AElement.name);
                this.fileBody534A = this.fileBody534AMap.get(tableFiles534AElement.name);
                this.selectedFile534A = tableFiles534AElement.file;

                const formData = new FormData();
                formData.append("file", this.selectedFile534A, this.selectedFile534A.name);

                try {
                    const result = await this.$refs.pdfLoader534A.on534ALoad(formData);

                    console.log("RESULT", result);

                    tableFiles534AElement.status = "Загружен успешно";
                } catch (e) {
                    console.log("CATCH", e);
                    tableFiles534AElement.status = "Не загружен";
                }
            }
        },

        async load_all534() {

            for (const tableFiles534Element of this.tableFiles534) {

                this.fileProp534 = this.fileProp534Map.get(tableFiles534Element.name);
                this.fileBody534 = this.fileBody534Map.get(tableFiles534Element.name);
                this.selectedFile534 = tableFiles534Element.file;

                const formData = new FormData();
                formData.append("file", this.selectedFile534, this.selectedFile534.name);

                try {

                    const result = await this.$refs.pdfLoader534.on534Load(formData);

                    console.log("RESULT", result);
                    tableFiles534Element.status = "Загружен успешно";

                } catch (e) {
                    console.log("CATCH", e);
                    tableFiles534Element.status = "Не загружен";

                }

            }

        },


        table_row_clicked (item) {
            this.fileProp534A = this.fileProp534AMap.get(item.name);
            this.fileBody534A = this.fileBody534AMap.get(item.name);
            this.selectedFile534A = item.file;
        },

        table_row_clicked534(item) {
            this.fileProp534 = this.fileProp534Map.get(item.name);
            this.fileBody534 = this.fileBody534Map.get(item.name);
            this.selectedFile534 = item.file;
        },

        async inputFile534A() {
            this.tableFiles534A = this.file534A.map((file, index) => ({
                index: index + 1,
                name: file.name,
                status: "",
                count: 0,
                file: file
            }));
            if (this.file534A.length>0) {
                this.busy3 = true;
                this.fileBody534AMap = new Map();
                this.fileProp534AMap = new Map();
                try {

                    for (const formDatum of this.file534A) {
                        const formData534A = new FormData();
                        formData534A.append('file', formDatum, formDatum.name);
                        await this.File534ALoad(formData534A, formDatum.name);
                        this.selectedFile534A = formDatum;
                    }
                    this.busy3 = false;
                } catch (exc) {
                    console.debug(exc);
                    this.busy3 = false;
                } finally {
                    this.busy3 = false;
                }
            }
        },
        // inputFile534() {
        //     const formData534 = new FormData();
        //     if (this.file534 !== null) {
        //         this.busy3 = true;
        //         formData534.append('file', this.file534, this.file534.name);
        //         this.File534Load(formData534);
        //     }
        // },

        async inputFile534() {

            this.tableFiles534 = this.file534.map((file, index) => ({
                index: index + 1,
                name: file.name,
                status: "",
                count: 0,
                file: file
            }));

            if (this.file534.length>0) {

                this.busy3 = true;

                this.fileBody534Map = new Map();
                this.fileProp534Map = new Map();

                try {

                    for (const formDatum of this.file534) {

                        const formData534 = new FormData();
                        formData534.append("file", formDatum, formDatum.name);

                        await this.File534Load(formData534, formDatum.name);

                        this.selectedFile534 = formDatum;
                    }

                } finally {

                    this.busy3 = false;

                }

            }

        },

        async File534ALoad(formData534A, fileName) {
            try {
                const response = await fetch('/api-py/check-h534A', {
                    method: 'POST',
                    credentials: 'include',
                    body: formData534A,
                });
                const result = await response.json();
                if (result === true) {
                    await this.pdfLoadHead534A(formData534A, fileName);
                } else {
                    this.makeToast(
                        'danger',
                        'Выбранный файл не соответствует шаблону!',
                        'Сообщение'
                    );
                }
            } catch (err) {
                console.debug(err);
                this.busy3 = false;
                this.busy3 = false;
                this.makeToast('danger', err.toString(), 'Ошибка запроса');
            }
        },
        async File534Load(formData534, fileName) {
            try {
                const response = await fetch('/api-py/check-h534', {
                    method: 'POST',
                    credentials: 'include',
                    body: formData534,
                });
                const result = await response.json();
                console.log(result);
                if (result === true) {
                    await this.pdfLoadHead534(formData534, fileName);
                } else {
                    this.busy3 = false;
                    this.makeToast(
                        'danger',
                        'Выбранный файл не соответствует шаблону!',
                        'Сообщение'
                    );
                }
            } catch (err) {
                console.debug(err);
                this.busy3 = false;
                this.busy3 = false;
                this.makeToast('danger', err.toString(), 'Ошибка запроса');
            }
        },
        async pdfLoadHead534A(formData534A, fileName) {
            try {
                Ax(
                    {
                        url: '/api-py/upload-h534A', // Заголовок файла
                        method: 'POST',
                        data: formData534A,
                    },
                    async (data) => {
                        this.fileProp534A = {...data};
                        this.fileProp534AMap.set(fileName, {...data});
                        await this.pdfLoadBody534A(formData534A, fileName);
                    },
                    (error) => {
                        this.error = error;
                        console.debug("error", error);
                        this.busy3 = false;
                    },
                );
            } catch (err) {
                console.debug("err", err);
                this.busy3 = false;
                this.makeToast('danger', err.toString(), 'Ошибка запроса');
            }
        },
        async pdfLoadHead534(formData534, fileName) {
            try {
                Ax(
                    {
                        url: '/api-py/upload-h534', // Заголовок файла
                        method: 'POST',
                        data: formData534,
                    },
                    async (data) => {
                        // запуск обновления данных о пользователе в общем хранилище
                        // возврат на предыдущую страницу
                        // this.busy3 = true;
                        this.fileProp534 = {...data};
                        this.fileProp534Map.set(fileName, { ...data });
                        this.pdfLoadBody534(formData534, fileName);
                    },
                    (error) => {
                        this.error = error;
                        console.debug(error);
                        this.busy3 = false;
                    },
                );
            } catch (err) {
                console.debug("err", err);
                this.busy3 = false;
                this.makeToast('danger', err.toString(), 'Ошибка запроса');
            }
        },
        pdfLoadHead420(formData420) {
            try {
                Ax(
                    {
                        url: '/api-py/upload-h420', // Заголовок файла
                        method: 'POST',
                        data: formData420,
                    },
                    (data) => {
                        // запуск обновления данных о пользователе в общем хранилище
                        // возврат на предыдущую страницу
                        // this.busy3 = true;
                        this.fileProp420 = {...data};
                        this.pdfLoadBody420(formData420);
                    },
                    (error) => {
                        this.error = error;
                        this.busy3 = false;
                    },
                    (this.busy3 = false)
                );
            } catch (err) {
                this.busy3 = false;
                this.makeToast('danger', err.toString(), 'Ошибка запроса');
            }
        },
        pdfLoadHead304(formData304) {
            try {
                Ax(
                    {
                        url: '/api-py/upload-h304', // Заголовок файла
                        method: 'POST',
                        data: formData304,
                    },
                    (data) => {
                        // запуск обновления данных о пользователе в общем хранилище
                        // возврат на предыдущую страницу
                        // this.busy3 = true;
                        this.fileProp304 = {...data};
                        this.pdfLoadBody304(formData304);
                    },
                    (error) => {
                        this.error = error;
                        this.busy3 = false;
                    },
                    (this.busy3 = false)
                );
            } catch (err) {
                this.busy3 = false;
                this.makeToast('danger', err.toString(), 'Ошибка запроса');
            }
        },

        pdfLoadHead302(formData302) {
            try {
                Ax(
                    {
                        url: '/api-py/upload-h302', // Заголовок файла
                        method: 'POST',
                        data: formData302,
                    },
                    (data) => {
                        // запуск обновления данных о пользователе в общем хранилище
                        // возврат на предыдущую страницу
                        // this.busy3 = true;
                        this.fileProp302 = {...data};
                        this.pdfLoadBody302(formData302);
                    },
                    (error) => {
                        this.error = error;
                        this.busy3 = false;
                    },
                    (this.busy3 = false)
                );
            } catch (err) {
                this.busy3 = false;
                this.makeToast('danger', err.toString(), 'Ошибка запроса');
            }
        },

        async pdfLoadBody534A(formData534A, fileName) {
            try {
                Ax(
                    {
                        url: '/api-py/upload-b534A', //  Тело файла
                        method: 'POST',
                        data: formData534A,
                    },
                    (data) => {
                        // this.busy3 = true;
                        this.fileBody534A = data;
                        this.fileBody534AMap.set(fileName, data);
                        this.tableFiles534A.find(vae => vae.name === fileName).count = data.length;
                        console.debug(fileName, data.length);
                    },
                    (error) => {
                        console.debug("error", error);
                        this.error = error;
                        this.busy3 = false;
                    }
                );
            } catch (err) {
                console.debug("err", err);
                this.busy3 = false;
                this.makeToast('danger', err.toString(), 'Ошибка запроса');
            }
        },
        async pdfLoadBody534(formData534, fileName) {
            try {
                Ax(
                    {
                        url: '/api-py/upload-b534', //  Тело файла
                        method: 'POST',
                        data: formData534,
                    },
                    (data) => {
                        // this.busy3 = true;
                        this.fileBody534 = data;
                        this.fileBody534Map.set(fileName, data);
                        // this.busy3 = false;
                        this.tableFiles534.find(vae => vae.name === fileName).count = data.length;
                        console.debug(fileName, data.length);
                    },
                    (error) => {
                        console.debug("error", error);
                        this.error = error;
                        this.busy3 = false;
                    }
                );
            } catch (err) {
                console.debug("err", err);
                this.busy3 = false;
                this.makeToast('danger', err.toString(), 'Ошибка запроса');
            }
        },
        pdfLoadBody420(formData420) {
            try {
                Ax(
                    {
                        url: '/api-py/upload-b420', //  Тело файла
                        method: 'POST',
                        data: formData420,
                    },
                    (data) => {
                        this.busy3 = true;
                        this.fileBody420 = data;
                        this.busy3 = false;
                    },
                    (error) => {
                        this.error = error;
                        this.busy3 = false;
                    }
                );
            } catch (err) {
                this.busy3 = false;
                this.makeToast('danger', err.toString(), 'Ошибка запроса');
            }
        },
        pdfLoadBody304(formData304) {
            try {
                Ax(
                    {
                        url: '/api-py/upload-b304', //  Тело файла
                        method: 'POST',
                        data: formData304,
                    },
                    (data) => {
                        this.busy3 = true;
                        this.fileBody304 = data;
                        this.busy3 = false;
                    },
                    (error) => {
                        this.error = error;
                        this.busy3 = false;
                    }
                );
            } catch (err) {
                this.busy3 = false;
                this.makeToast('danger', err.toString(), 'Ошибка запроса');
            }
        },

        pdfLoadBody302(formData302) {
            try {
                Ax(
                    {
                        url: '/api-py/upload-b302', //  Тело файла
                        method: 'POST',
                        data: formData302,
                    },
                    (data) => {
                        this.busy3 = true;
                        this.fileBody302 = data;
                        this.busy3 = false;
                    },
                    (error) => {
                        this.error = error;
                        this.busy3 = false;
                    }
                );
            } catch (err) {
                this.busy3 = false;
                this.makeToast('danger', err.toString(), 'Ошибка запроса');
            }
        },

        inputFile520() {
            const formData520 = new FormData();
            if (this.file520 !== null) {
                this.busy3 = true;
                formData520.append('file', this.file520, this.file520.name);
                this.File520Load(formData520);
            }
        },
        inputFile515() {
            const formData515 = new FormData();
            if (this.file515 !== null) {
                this.busy3 = true;
                formData515.append('file', this.file515, this.file515.name);
                this.File515Load(formData515);
            }
        },
        async File520Load(formData520) {
            try {
                const response = await fetch('/api-py/check-h520', {
                    method: 'POST',
                    credentials: 'include',
                    body: formData520,
                });
                const result = await response.json();
                console.log(result);
                if (result === true) {
                    await this.pdfLoadHead520(formData520);
                } else {
                    this.busy3 = false;
                    this.makeToast(
                        'danger',
                        'Выбранный файл не соответствует шаблону!',
                        'Сообщение'
                    );
                }
            } catch (err) {
                this.busy3 = false;
                this.makeToast('danger', err.toString(), 'Ошибка запроса');
            }
        },
        async File515Load(formData515) {
            try {
                const response = await fetch('/api-py/check-h515', {
                    method: 'POST',
                    credentials: 'include',
                    body: formData515,
                });
                const result = await response.json();
                console.log(result);
                if (result === true) {
                    await this.pdfLoadHead515(formData515);
                } else {
                    this.busy3 = false;
                    this.makeToast(
                        'danger',
                        'Выбранный файл не соответствует шаблону!',
                        'Сообщение'
                    );
                }
            } catch (err) {
                this.busy3 = false;
                this.makeToast('danger', err.toString(), 'Ошибка запроса');
            }
        },
        pdfLoadHead520(formData520) {
            try {
                Ax(
                    {
                        url: '/api-py/upload-h520', // Заголовок файла
                        method: 'POST',
                        data: formData520,
                    },
                    (data) => {
                        // запуск обновления данных о пользователе в общем хранилище
                        // возврат на предыдущую страницу
                        this.busy3 = true;
                        this.fileProp520 = {...data};
                        this.pdfLoadBody520(formData520);
                    },
                    (error) => {
                        this.error = error;
                        this.busy3 = false;
                    },
                    (this.busy3 = false)
                );
            } catch (err) {
                this.busy3 = false;
                this.makeToast('danger', err.toString(), 'Ошибка запроса');
            }
        },
        pdfLoadHead515(formData515) {
            try {
                Ax(
                    {
                        url: '/api-py/upload-h515', // Заголовок файла
                        method: 'POST',
                        data: formData515,
                    },
                    (data) => {
                        // запуск обновления данных о пользователе в общем хранилище
                        // возврат на предыдущую страницу
                        // this.busy3 = true;
                        this.fileProp515 = {...data};
                        this.pdfLoadBody515(formData515);
                    },
                    (error) => {
                        this.error = error;
                        this.busy3 = false;
                    },
                    (this.busy3 = false)
                );
            } catch (err) {
                this.busy3 = false;
                this.makeToast('danger', err.toString(), 'Ошибка запроса');
            }
        },
        pdfLoadBody520(formData520) {
            try {
                Ax(
                    {
                        url: '/api-py/upload-b520', //  Тело файла
                        method: 'POST',
                        data: formData520,
                    },
                    (data) => {
                        this.busy3 = true;
                        this.fileBody520 = data;
                        this.busy3 = false;
                    },
                    (error) => {
                        this.error = error;
                        this.busy3 = false;
                    }
                );
            } catch (err) {
                this.busy3 = false;
                this.makeToast('danger', err.toString(), 'Ошибка запроса');
            }
        },
        pdfLoadBody515(formData515) {
            try {
                Ax(
                    {
                        url: '/api-py/upload-b515', //  Тело файла
                        method: 'POST',
                        data: formData515,
                    },
                    (data) => {
                        this.busy3 = true;
                        this.fileBody515 = data;
                        this.busy3 = false;
                    },
                    (error) => {
                        this.error = error;
                        this.busy3 = false;
                    }
                );
            } catch (err) {
                this.busy3 = false;
                this.makeToast('danger', err.toString(), 'Ошибка запроса');
            }
        },
        inputFile552() {
            const formData552 = new FormData();
            if (this.file552 !== null) {
                formData552.append('file', this.file552, this.file552.name);
                this.File552Load(formData552);
            }
        },
        async File552Load(formData552) {
            try {
                const response = await fetch('/api-py/check-h552', {
                    method: 'POST',
                    credentials: 'include',
                    body: formData552,
                });
                const result = await response.json();
                console.log(result);
                if (result === true) {
                    await this.pdfLoadHead552(formData552);
                } else {
                    this.busy4 = false;
                    this.makeToast(
                        'danger',
                        'Выбранный файл не соответствует шаблону!',
                        'Сообщение'
                    );
                }
            } catch (err) {
                this.makeToast('danger', err.toString(), 'Ошибка запроса');
            }
        },
        pdfLoadHead552(formData552) {
            try {
                Ax(
                    {
                        url: '/api-py/upload-h552', // Заголовок файла
                        method: 'POST',
                        data: formData552,
                    },
                    (data) => {
                        this.busy4 = true;
                        this.fileHead552 = JSON.parse(data);
                        this.fileProp552.name = this.fileHead552[0].fileName;
                        this.fileProp552.data = this.fileHead552[0].data;
                        this.fileProp552.vid = this.fileHead552[0].vid;
                        this.fileProp552.region = this.fileHead552[0].region;
                        this.fileProp552.source = this.fileHead552[0].source;
                        this.fileProp552.spec = this.fileHead552[0].spec;
                        this.pdfLoadBody552(formData552);
                    },
                    (error) => {
                        this.error = error;
                        this.busy4 = false;
                    },
                    (this.busy4 = false)
                );
            } catch (err) {
                this.busy4 = false;
                this.makeToast('danger', err.toString(), 'Ошибка запроса');
            }
        },
        pdfLoadBody552(formData552) {
            try {
                Ax(
                    {
                        url: '/api-py/upload-b552', //  Тело файла
                        method: 'POST',
                        data: formData552,
                    },
                    (data) => {
                        this.busy4 = true;
                        this.fileBody552 = JSON.parse(data);
                        this.busy4 = false;
                    },
                    (error) => {
                        this.error = error;
                        this.busy4 = false;
                    }
                );
            } catch (err) {
                this.busy4 = false;
                this.makeToast('danger', err.toString(), 'Ошибка запроса');
            }
        },

        async inputFile127() {
            const formData127 = new FormData();
            if (this.file127 !== null) {
                this.busy6 = true;
                formData127.append('file', this.file127, this.file127.name);
                if (this.file127.name.endsWith('xls') || this.file127.name.endsWith('xlsx')) {
                    this.fileLoadHead127(formData127);
                } else {
                    this.busy6 = true;
                    try {
                        await this.filePreLoad127_xml(formData127);
                    } finally {
                        this.busy6 = false;
                    }
                }
            }
        },

        filePreLoad127_xml(formData127) {
            const reader = new FileReader();
            reader.readAsText(this.file127);
            reader.onload = async (event) => {
                this.busy6 = true;
                const xmlString = event.target.result;
                const parser = new DOMParser();
                const xmlDoc = parser.parseFromString(xmlString, 'text/xml');
                // Преобразуем XML в строку для отображения
                const xmlContent = new XMLSerializer().serializeToString(xmlDoc);
                const document = xmlDoc.getElementsByTagName('repdate')[0].textContent;
                this.fileProp127.name = xmlDoc.documentElement.getAttribute('type');
                const [day, month, year] = xmlDoc.getElementsByTagName('repdate')[0].textContent.split('.');
                this.fileProp127.month = month;
                this.fileProp127.year = year;
                this.fileProp127.day = day;
                this.fileProp127.mesuare = 'тенге';
                this.fileProp127.rep_date = xmlDoc.getElementsByTagName('repdate')[0].textContent;
                this.fileProp127.region = await this.getRegionByCode(xmlDoc.getElementsByTagName('obl')[0].textContent + xmlDoc.getElementsByTagName('reg')[0].textContent);
                this.fileProp127.vid = xmlDoc.getElementsByTagName('bud')[0].textContent;
                const rows_array = xmlDoc.getElementsByTagName('row');
                const table_items = [];
                const data_items = [];
                let ebk_data = []
                this.fileLoadHead127_xml(formData127);
                const result = await fetch('/api-py/dict-ebk-func-actual-code-date/2024-06-18');
                if (result.status === 200) {
                    ebk_data = await result.json();
                }
                for (const row of rows_array) {
                    const table_row = {
                        code: await this.generate_code_by_xml_row(row),
                        name: await this.get_code_name_by_xml_row(row),
                        utv_budget: Number(row.getElementsByTagName('utv')[0].textContent),
                        utoch_budget: Number(row.getElementsByTagName('utch')[0].textContent),
                        skor_plan: Number(row.getElementsByTagName('plg')[0].textContent),
                        spf_obaz: Number('0'),
                        spf_plat: Number(row.getElementsByTagName('plgp')[0].textContent),
                        accept_obaz: Number('0'),
                        unpaid_obaz: Number('0'),
                        exec_prg: Number(row.getElementsByTagName('sumrg')[0].textContent)
                    }

                    const data_row = {
                        budgetType: this.get_row_data(row, 'bud', 'bud'),
                        code: this.get_row_data(row, 'obl', 'bud') + this.get_row_data(row, 'reg', 'reg'),
                        codeCurrency: 'Тенге',
                        isValid: false,

                        pcl_abp: this.removeLeadingZeros(this.get_row_data(row, 'pkl', 'uch')),
                        spf_prg: this.removeLeadingZeros(this.get_row_data(row, 'prg', 'spk')),
                        ppr: this.removeLeadingZeros(this.get_row_data(row, 'pprg', 'pprg')),
                        spf: (this.get_row_data(row, 'kat', 'kat') == null) ? this.removeLeadingZeros(this.get_row_data(row, 'spk', 'spk')) : '',
                        year: year,
                        month: month,
                        nplobz: Number('0'),
                        obz: this.get_row_data(row, 'obz', 'obz', 0) != 0 ? this.get_row_data(row, 'obz', 'obz', 0) / 1000 : 0,
                        plg: this.get_row_data(row, 'plg', 'plg', 0) != 0 ? this.get_row_data(row, 'plg', 'plg', 0) / 1000 : 0,
                        plgo: this.get_row_data(row, 'plgo', 'plgo', 0) != 0 ? this.get_row_data(row, 'plgo', 'plgo', 0) / 1000 : 0,
                        plgp: this.get_row_data(row, 'plgp', 'plgp', 0) != 0 ? this.get_row_data(row, 'plgp', 'plgp', 0) / 1000 : 0,
                        sumrg: this.get_row_data(row, 'sumrg', 'sumrg', 0) != 0 ? this.get_row_data(row, 'sumrg', 'sumrg', 0) / 1000 : 0,
                        utch: this.get_row_data(row, 'utch', 'utch', 0) != 0 ? this.get_row_data(row, 'utch', 'utch', 0) / 1000 : 0,
                        utv: this.get_row_data(row, 'utv', 'utv', 0) != 0 ? this.get_row_data(row, 'utv', 'utv', 0) / 1000 : 0,
                        reportDate: this.convertToTimestampUTC(this.get_row_data(row, 'repdate')),
                        title: await this.get_code_name_by_xml_row(row),
                        username: 'user_test_xml',
                    }
                    if (row.getElementsByTagName('uch').length > 0) {
                        const code = ebk_data.filter(value => (value.abp == row.getElementsByTagName('uch')[0].textContent
                            & value.prg == row.getElementsByTagName('prg')[0].textContent & value.ppr == row.getElementsByTagName('pprg')[0].textContent));
                        if (code.length > 0) {
                            data_row.kat_gr = code[0].gr;
                            data_row.cls_pgr = code[0].pgr;
                        }
                    } else {
                        data_row.kat_gr = this.removeLeadingZeros(this.get_row_data(row, 'kat', 'gr'));
                        data_row.cls_pgr = this.removeLeadingZeros(this.get_row_data(row, 'kls', 'kls'));
                    }
                    data_items.push(data_row);
                    table_items.push(table_row);
                }
                this.fileBody127 = table_items;
                this.fileHead127.budgetList = data_items;
                this.busy6 = false;
            };
        },

        removeLeadingZeros(str) {
            const number = parseInt(str, 10);
            return isNaN(number) ? '0' : number.toString();
        },

        convertToTimestampUTC(dateString) {
            const [day, month, year] = dateString.split('.').map(Number);
            const timestamp = Date.UTC(year, month - 1, day);
            return timestamp;
        },

        get_row_data(xml_row, field, field_alt, defult) {
            if (xml_row.getElementsByTagName(field).length > 0) {
                return xml_row.getElementsByTagName(field)[0].textContent
            } else if (xml_row.getElementsByTagName(field_alt).length > 0) {
                return xml_row.getElementsByTagName(field_alt)[0].textContent
            } else {
                if (defult != undefined) {
                    return defult
                } else {
                    return null
                }
            }
        },

        async generate_code_by_xml_row(xml_row) {
            if (xml_row.getElementsByTagName('kat').length > 0) {
                const result = xml_row.getElementsByTagName('kat')[0].textContent +
                    xml_row.getElementsByTagName('kls')[0].textContent + xml_row.getElementsByTagName('pkl')[0].textContent +
                    xml_row.getElementsByTagName('spk')[0].textContent;
                return result;
            } else {
                const result = xml_row.getElementsByTagName('uch')[0].textContent +
                    xml_row.getElementsByTagName('prg')[0].textContent + xml_row.getElementsByTagName('pprg')[0].textContent +
                    xml_row.getElementsByTagName('spk')[0].textContent;
                return result;
            }
        },

        async get_code_name_by_xml_row(xml_row) {
            if (xml_row.getElementsByTagName('kat').length > 0) {
                const param = {
                    kat: xml_row.getElementsByTagName('kat')[0].textContent,
                    cls: xml_row.getElementsByTagName('kls')[0].textContent,
                    pcl: xml_row.getElementsByTagName('pkl')[0].textContent,
                    spf: xml_row.getElementsByTagName('spk')[0].textContent
                }
                const result = await fetch('/api-py/get-income-ebk-code', {
                    method: 'POST',
                    body: JSON.stringify(param)
                })
                if (result.status === 200) {
                    const data = await result.json();
                    const res = data.ebk_code[3].name_ru;
                    return res
                } else {
                    this.makeToast('danger', 'get-budget-clarify-rate', `${result.status} - ${result.statusText}`);
                    return;
                }
            } else {
                const spf = xml_row.getElementsByTagName('spk')[0].textContent;
                const num = xml_row.getAttribute('num');
                if (this.spfMap.has(spf)) {
                    const data = this.spfMap.get(spf);
                    let res = 'Нет специфики'
                    if (data.length > 0) {
                        if (data[0]) {
                            res = data[0].name_ru;
                        }
                    } else {
                        if (data) {
                            if (data.name_ru) {
                                res = data.name_ru;
                            }
                        }
                    }
                    return res
                }
                const result = await fetch('/api-py/dict-ebk-spf/' + spf);
                if (result.status === 200) {
                    const data = await result.json();
                    this.spfMap.set(spf, data);
                    let res = 'Нет специфики'
                    if (data.length > 0) {
                        if (data[0]) {
                            res = data[0].name_ru;
                        }
                    } else {
                        if (data) {
                            if (data.name_ru) {
                                res = data.name_ru;
                            }
                        }
                    }
                    return res
                } else {
                    this.makeToast('danger', 'get_code_name_by_xml_row', `${result.status} - ${result.statusText}`);
                    return;
                }
            }
        },

        fileLoadHead127_xml(formData127) {
            try {
                const date = this.fileProp127.year + '-' + this.fileProp127.month + '-' + this.fileProp127.day + ' 00:00:00:00';
                Ax(
                    {
                        url: '/api/excel/upload-form127?report-date=' + date + '&region=' + this.fileProp127.region.substring(0, 6) + '&budget-type=' + this.fileProp127.vid.substring(1), //  Тело файла
                        method: 'POST',
                        data: formData127,
                    },
                    (data) => {
                        this.fileHead127 = data;
                        this.fileProp127.isExists =
                            this.fileHead127.headerDto.isExists;
                        // this.fileBody552 = JSON.parse(data);
                    },
                    (error) => {
                        this.error = error;
                    }
                );
            } catch (err) {
                this.makeToast('danger', err.toString(), 'Ошибка запроса');
            }
        },

        async fileLoadHead127(formData127) {
            try {
                const response = Ax(
                    {
                        url: '/api/excel/upload-form127',
                        method: 'POST',
                        data: formData127,
                    },
                    (data) => {
                        this.fileHead127 = data;
                        this.busy6 = false;
                        this.fileProp127.name =
                            this.fileHead127.headerDto.title;
                        this.fileProp127.mesuare =
                            this.fileHead127.headerDto.unit;
                        this.fileProp127.region = `${this.fileHead127.headerDto.region} - ${this.fileHead127.headerDto.regionName}`;
                        const date = new Date(
                            this.fileHead127.headerDto.reportDate
                        );
                        this.fileProp127.rep_date = date.getDate();
                        this.fileProp127.month = date.getMonth() + 1;
                        this.fileProp127.year = date.getFullYear();
                        this.fileProp127.vid = `${this.fileHead127.headerDto.budgetType} - ${this.fileHead127.headerDto.budgetName}`;
                        this.fileHead127.budgetList.forEach((item) => {
                            this.fileBody127.push({
                                code: `${item.kat_gr}${item.cls_pgr}${
                                    item.pcl_abp
                                }${item.spf_prg}${item.ppr ? item.ppr : ''}${
                                    item.spf ? item.spf : ''
                                }`,
                                name: item.title,
                                utv_budget: item.utv,
                                utoch_budget: item.utch,
                                skor_plan: item.plg,
                                spf_plat: item.plgp,
                                spf_obaz: item.plgo,
                                accept_obaz: item.obz,
                                unpaid_obaz: item.nplobz,
                                exec_prg: item.sumrg,
                            });
                        });
                        this.fileProp127.isExists =
                            this.fileHead127.headerDto.isExists;
                    },
                    (error) => {
                        this.error = error;
                        this.makeToast(
                            'danger',
                            'Выбранный файл не соответствует шаблону!',
                            'Сообщение'
                        );
                        this.busy6 = false;
                    }
                );
            } catch (err) {
                this.busy6 = false;
                this.makeToast('danger', err.toString(), 'Ошибка запроса');
            }
        },
        inputFile420() {
            const formData420 = new FormData();
            if (this.file420 !== null) {
                this.busy7 = true;
                formData420.append('file', this.file420, this.file420.name);
                this.fileLoadHead420(formData420);
            }
        },
        inputFile420pdf() {
            const formData420 = new FormData();
            if (this.file420pdf !== null) {
                this.busy3 = true;
                formData420.append('file', this.file420pdf, this.file420pdf.name);
                this.fileLoadHead420pdf(formData420);
            }
        },
        inputFile304() {
            const formData304 = new FormData();
            if (this.file304pdf !== null) {
                this.busy3 = true;
                formData304.append('file', this.file304pdf, this.file304pdf.name);
                this.fileLoadHead304(formData304);
            }
        },

        inputFile302() {
            const formData302 = new FormData();
            if (this.file302pdf !== null) {
                this.busy3 = true;
                formData302.append('file', this.file302pdf, this.file302pdf.name);
                this.fileLoadHead302(formData302);
            }
        },

        fileLoadHead420(formData420) {
            try {
                const response = Ax(
                    {
                        url: '/api/excel/upload-form420',
                        method: 'POST',
                        data: formData420,
                    },
                    (data) => {
                        this.fileHead420 = data;
                        this.busy7 = false;
                        this.fileProp420.name =
                            this.fileHead420.headerDto.title;
                        this.fileProp420.measure =
                            this.fileHead420.headerDto.unit;
                        this.fileProp420.region = `${this.fileHead420.headerDto.region} - ${this.fileHead420.headerDto.regionName}`;
                        const date = new Date(
                            this.fileHead420.headerDto.reportDate
                        );
                        this.fileProp420.repdate = `${date.getDate()}.${(date.getMonth() + 1).toString().padStart(2, '0')}.${date.getFullYear()}`;
                        this.fileProp420.year = date.getFullYear();
                        this.fileProp420.vid = `${this.fileHead420.headerDto.budgetType} - ${this.fileHead420.headerDto.budgetName}`;
                        this.fileProp420.abp = this.fileHead420.headerDto.abp;
                        this.fileProp420.gu = `${this.fileHead420.headerDto.gu} - ${this.fileHead420.headerDto.guName}`;
                        this.fileHead420.budgetList.forEach((item) => {
                            this.fileBody420.push({
                                code: item.func,
                                code_spf: item.spf,
                                name: item.funcName,
                                spf: item.plg,
                                spf_plat: item.plg,
                                spf_obaz: item.obaz,
                                accept_obaz: item.registrob,
                                paid_obaz_year: item.sumrg,
                                paid_obaz_month: item.currSumrg,
                                unpaid_obaz: item.notexec,
                            });
                        });
                        this.fileProp420.isExists =
                            this.fileHead420.headerDto.isExists;
                    },
                    (error) => {
                        this.error = error;
                        this.makeToast(
                            'danger',
                            'Выбранный файл не соответствует шаблону!',
                            'Сообщение'
                        );
                        this.busy7 = false;
                    }
                );
            } catch (err) {
                this.busy7 = false;
                this.makeToast('danger', err.toString(), 'Ошибка запроса');
            }
        },
        async fileLoadHead420pdf(formData420) {
            try {
                const response = await fetch('/api-py/check-h420', {
                    method: 'POST',
                    credentials: 'include',
                    body: formData420,
                });
                const result = await response.json();
                if (result === true) {
                    await this.pdfLoadHead420(formData420);
                } else {
                    this.busy3 = false;
                    this.makeToast(
                        'danger',
                        'Выбранный файл не соответствует шаблону!',
                        'Сообщение'
                    );
                }
            } catch (err) {
                this.busy3 = false;
                this.makeToast('danger', err.toString(), 'Ошибка запроса');
            }
        },
        async fileLoadHead304(formData304) {
            try {
                // this.makeToast("danger", "Дошли сюда",  "304 form");
                const response = await fetch('/api-py/check-h304', {
                    method: 'POST',
                    credentials: 'include',
                    body: formData304,
                });
                const result = await response.json();
                if (result === true) {
                    await this.pdfLoadHead304(formData304);
                } else {
                    this.busy3 = false;
                    this.makeToast(
                        'danger',
                        'Выбранный файл не соответствует шаблону!',
                        'Сообщение'
                    );
                }
            } catch (err) {
                this.busy3 = false;
                this.makeToast('danger', err.toString(), 'Ошибка запроса');
            }
        },

        async fileLoadHead302(formData302) {
            try {
                // this.makeToast("danger", "Дошли сюда",  "302 form");
                const response = await fetch('/api-py/check-h302', {
                    method: 'POST',
                    credentials: 'include',
                    body: formData302,
                });
                const result = await response.json();
                if (result === true) {
                    await this.pdfLoadHead302(formData302);
                } else {
                    this.busy3 = false;
                    this.makeToast(
                        'danger',
                        'Выбранный файл не соответствует шаблону!',
                        'Сообщение'
                    );
                }
            } catch (err) {
                this.busy3 = false;
                this.makeToast('danger', err.toString(), 'Ошибка запроса');
            }
        },

        keyEvent(event) {
        },
        formClear(filt) {
            this.file1 = filt;
            this.fileBody = [];
        },
        formClear5(filt) {
            this.file5 = filt;
            this.fileBody5 = [];
        },
        formClear219(filt) {
            this.file219 = filt;
            this.fileBody219 = [];
        },
        formClear243(filt) {
            this.file243 = filt;
            this.fileBody243 = [];
        },
        formClear534A(filt) {
            this.file534A = filt;
            this.fileBody534A = [];
            this.fileProp534A = {
                file_name: '',
                report_date: '',
                unit: '',
                budget_type: '',
                region: '',
                period: '',
                abp: '',
                funding_source: '',
                spf: '',
                code_gu: '',
                report_name: ''
            }
        },
        formClear534(filt) {
            this.file534 = filt;
            this.fileBody534 = [];
            this.fileProp534 = {
                file_name: '',
                report_date: '',
                unit: '',
                budget_type: '',
                region: '',
                period: '',
                abp: '',
                funding_source: '',
                spf: '',
                code_gu: '',
                report_name: ''
            }
        },
        formClear520() {
            this.file520 = Object;
            this.fileBody520 = [];
            this.fileProp520 = {
                file_name: '',
                report_date: '',
                unit: '',
                budget_type: '',
                region: '',
                period: '',
                abp: '',
                funding_source: '',
                spf: '',
                code_gu: '',
                report_name: '',
                prev_period: '',
                bik: '',
                iik: '',
                year_beginning_balance: 0,
                closing_balance: 0,
                opening_balance: 0,
                region_code: '',
                budget_type_code: '',
                funding_source_code: '',
            }
        },
        formClear515(filt) {
            this.file515 = filt;
            this.fileBody515 = [];
            this.fileProp515 = {}
        },
        formClear552(filt) {
            this.file552 = filt;
            this.fileBody552 = [];
        },
        formClear127(filt) {
            this.file127 = filt;
            this.fileBody127 = [];
        },
        formClear420(filt) {
            this.file420 = {};
            this.fileBody420 = [];
        },
        formClear420pdf(filt) {
            this.file420pdf = [];
            this.fileProp420 = {};
            this.fileBody420 = [];
        },

        formClear304pdf(filt) {
            this.file304pdf = [];
            this.fileProp304 = {};
            this.fileBody304 = [];
        },

        formClear302pdf(filt) {
            this.file302pdf = [];
            this.fileProp302 = {};
            this.fileBody302 = [];
        },

        saveLoad(param) {
            this.busy1 = param;
        },
        saveLoad5(param) {
            this.busy5 = param;
        },
        saveLoad219(param) {
            this.busy2 = param;
        },
        saveLoad243(param) {
            this.busy3 = param;
        },
        saveLoad534A(param) {
            this.busy3 = param;
        },
        saveLoad534(param) {
            this.busy3 = param;
        },
        saveLoad520(param) {
            this.busy3 = param;
        },
        saveLoad515(param) {
            this.busy3 = param;
        },
        saveLoad552(param) {
            this.busy4 = param;
        },
        saveLoad127(param) {
            this.busy6 = param;
        },
        saveLoad420(param) {
            this.busy7 = param;
        },
        saveLoad420pdf(param) {
            this.busy3 = param;
        },

        saveLoad304pdf(param) {
            this.busy3 = param;
        },

        saveLoad302pdf(param) {
            this.busy3 = param;
        },

        makeToast(variant = null, tostbody, title) {
            this.$bvToast.toast(tostbody, {
                title: title,
                variant: variant,
                autoHideDelay: 2000,
                solid: true,
            });
        },
        parseDateString(dateString) {
            const [year, month, day] = dateString.split('-');
            return new Date(`${year}-${month}-${day}`);
        },
        async getRegionByCode(code) {
            try {
                const request = await fetch('/api-py/dict-region-by-code/' + code);
                const response = await request.json();
                if (response.length == 1) {
                    return response[0].code + ' - ' + response[0].name_ru;
                } else if (response.length > 1) {
                    for (const reg of response) {
                        if (this.parseDateString(reg.end_date) > Date.now()) {
                            const res = reg.code + ' - ' + reg.name_ru;
                            return res;
                        }
                    }
                } else {
                    return code
                }
            } catch (e) {
                return e
            } finally {
            }
        }
    },
    computed: {},
};
</script>

<style scoped></style>
